import React from 'react'
import Footer from '../../../components/Footer'
import ScienceImg from "../../../assets/images/science.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';

const MSCMathematics = () => {
    return (
        <div className='  w-full relative font-poppins ' >
            <Title canonicalPath="/programmes/ug-courses/sciences/msc/mathematics
" />
            <Title title="M.Sc. in Mathematics at Maya Devi University" description="Join M.Sc. in Mathematics at MDU, Dehradun. Strengthen your analytical skills and open doors to careers in research, education, and data science.
" />
            <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
                <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>M.Sc. Mathematics</h2>
                <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
                <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[60px] mt-5 justify-center md:justify-between ' >
                    <img src={ScienceImg} className=' md:w-[40%] rounded-lg ' alt='Student in a bio lab' />
                    <div className=' flex flex-col gap-4 ' >
                        <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
                        <p className=' text-justify md:text-md ' >The Master of Science in Mathematics programme in MDU is a full time one year/two year programme that provides a strong foundation of fundamental and advanced aspects of Mathematics and their applications. It includes various subjects such as algebra, analysis, topology, and applied mathematics. Students deepen their understanding of mathematical theories, develop problem-solving skills, and often engage in research projects. This degree is useful in academia, research, finance, data science, engineering, and many other fields where advanced quantitative skills are valued.
                            <br /><br />
                            The Department of Mathematics at Maya Devi University aims to foster a stimulating academic environment where students can explore advanced mathematical concepts, engage in research and develop a deep appreciation for the versatility of mathematics.

                            The Mathematics Department at Maya Devi University is known for its cutting-edge curriculum that equips students with strong analytical and problem-solving skills that are essential in various fields including science, engineering, finance, and technology.</p>
                        <Link to="https://admission.maya.edu.in/" >
                            <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
                            >Register Now</button>
                        </Link>
                    </div>
                </div>

                <div className=' flex flex-col gap-10 mt-5 mb-[20px] ' >
                    <div className=' flex flex-col gap-2 ' >
                        <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
                        <p>B.Sc. with Mathematics as one of the subjects studied in all three years and Mathematics as one of the subsidiary subjects with not less than 50% marks in aggregate and not less than 50% marks in Physics</p>
                    </div>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Programme Outcomes</h4>
                    <p>After completion of the program, the students have:</p>
                    <ul className=' list-disc ' >
                        <li>Communicate mathematics effectively by written, computational, and graphic means.</li>
                        <li>Create mathematical ideas from basic axioms.</li>
                        <li>Gauge hypotheses, theories, techniques, and proofs provisionally.</li>
                        <li>Utilize mathematics to solve theoretical and applied problems by critical understanding, analysis, and synthesis.</li>
                        <li>Identify applications of mathematics in other disciplines and in the real world, leading to enhancement of career prospects in a plethora of fields and research.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Prospects of the Course </h4>
                    <p>A post graduate degree in Mathematics opens up a wide array of career opportunities across various industries.</p>
                    <ul className=' list-disc ' >
                        <li>
                            This course gives Mathematics enthusiasts a possibility to develop their mathematical and communication skills and apply critical thinking that would help them to interpret scientific data collected from diverse sources. This skill set is always a boon to scientific researchers. One can apply in government and private colleges/universities to pursue his teaching career. One can go for jobs in prominent national organizations like DRDO, ISRO, NTPC, ONGC and ISS. At the same time one can also look out for the national laboratories and institutes.</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Career Options</h4>
                    <p>After completing a Master of Science in Physics, there are different career options available:</p>
                    <ul className=' list-disc ' >
                        <li>Data Analyst/Data Scientist</li>
                        <li>Statistician</li>
                        <li>Mathematician</li>
                        <li>Financial Analyst</li>
                        <li>Quantitative Analyst</li>
                        <li>Teaching/Academia</li>
                    </ul>
                </div>

                <div className=' flex flex-col gap-2 mt-[20px] mb-[30px] ' >
                    <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>USPs</h4>
                    <ul className=' list-disc ' >
                        <li>Energetic and dedicated faculty members in many diverse areas of mathematics.</li>
                        <li>Advanced Course Curriculum designed by Core Academia & Renowned Industry Experts.</li>
                        <li>Live Industry Projects based Learning throughout the course.</li>
                        <li>LMS-based Pedagogy and Innovative Classroom Teaching Methodology.</li>
                        <li>Choice Based Credit System (CBCS) Based Assessments and Evaluation.</li>
                        <li>Full-Time Industrial Internship after the 3rd year.</li>
                        <li>Advanced Diagnostic & Mentoring for Career and Placement throughout the Course.</li>
                        <li>Dynamic Programming & Core Skill Guidance throughout the course.</li>
                        <li>Start-up & Idea Innovation Lab for Career & Professional Growth.</li>
                    </ul>
                </div>

                {/* table */}
                <div className="flex flex- mb-[100px] ">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                            <div className="overflow-hidden">
                                <table className="min-w-full text-center text-sm font-light">
                                    <thead
                                        className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                                        <tr>
                                            <th scope="col" className=" px-6 py-4">Programme</th>
                                            <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
                                            <th scope="col" className=" px-6 py-4">Duration (Years)</th>
                                            <th scope="col" className=" px-6 py-4">No. of Seats</th>
                                            {/* <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
                                            <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="border-b dark:border-neutral-500">
                                            <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Master of Science</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Mathematics</td>
                                            <td className="whitespace-nowrap  px-6 py-4">2</td>
                                            <td className="whitespace-nowrap  px-6 py-4">20</td>
                                            {/* <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.60000/-</td>
                                            <td className="whitespace-nowrap  px-6 py-4">Rs.45000/-</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default MSCMathematics